import Header from 'components/Header/Header';
import HomePage from 'components/PageHome/PageHome';

const IndexPage = () => {
  return (
    <>
      <Header className="home-header" />
      <HomePage />
    </>
  );
};

export default IndexPage;
